/* globals Store */
import { Data } from '../../models'
import axios from 'axios';
import VueRouter from 'vue-router';

const state = {
    data: new Data(),
}

const actions = {
    callpage({commit},item){

      commit("setpage",item);

      },
      login({commit},payload) {
        // console.log(state.data.url)
        axios.post(state.data.url+'/linkroom/api/v1/login',payload)
        // axios.post(state.data.url+'/linksroom/api/v1/loginad',payload)
        .then(response => {
            // console.log(response.data)
            if(response.status == 200){
              // console.log(response.data.status)
            //   console.log(response.data.data.token)
              if(response.data.status === 200 && response.data.data.type === "admin"){

                  // console.log("banana")
                  commit("settoken",response.data.data.token);
                  commit("setemail",payload)
                
              }
              else {
                // console.log(response.data)
                commit("setalart",response.data.status_text);
              }
            }
            })

            
      },
      changebookingstatus({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
      // con
      axios.post(state.data.url+'/linkroom/api/admin/v1/changebookingstatus',payload, {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            actions.getbooking({commit})
            // console.log(response.data.listbooking)
 
          }
        })
      },
      changeequipment({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
      // con
      axios.post(state.data.url+'/linkroom/api/admin/v1/changeeequipment',payload, {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            actions.getlistequipment({commit})
            // console.log(response.data.listbooking)
 
          }
        })
      },
      updateuser({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/changeuserprofiles',payload, {
          headers: headers
        })
        .then(response => {
          // console.log(response.data.status_code)
          if(response.data.status_code === 200){
              actions.getlistuser({commit})
            // actions.getbooking({commit})
            // console.log(response.data.listbooking)
 
          }
        })
      },
      updateroom({commit},payload){
      const headers = {
        'Authorization' : state.data.token
    }
      axios.post(state.data.url+'/linkroom/api/admin/v1/changeroomprofiles',payload, {
        headers: headers
      })
      .then(response => {
        // console.log(response.data.status_code)
        if(response.data.status_code === 200){
            actions.getlistroom({commit})
          // actions.getbooking({commit})
          // console.log(response.data.listbooking)

        }
      })
    },
      adduser({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/adduser',payload, {
          headers: headers
        })
        .then(response => {
          // console.log(response.data.status_code)
          if(response.data.status_code === 200){
              actions.getlistuser({commit})
            // actions.getbooking({commit})
            // console.log(response.data.listbooking)
 
          }
        })
      },
      deleteuser({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/deleteuser',payload, {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            actions.getlistuser({commit})
          }
        })

      },
      resetpassword({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/resetpassword',payload, {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            actions.getlistuser({commit})
          }
        })

      },
      deleteequipment({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/deleteequipment',payload, {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            actions.getlistequipment({commit})
          }
        })

      },
      additem({commit},payload){
        const headers = {
          'Authorization' : state.data.token
      }
        axios.post(state.data.url+'/linkroom/api/admin/v1/addequipment',payload, {
          headers: headers
        })
        .then(response => {
          // console.log(response.data.status_code)
          if(response.data.status_code === 200){
              actions.getlistequipment({commit})
            // actions.getbooking({commit})
            // console.log(response.data.listbooking)
 
          }
        })
      },
      logout({commit}) {

        const headers = {
          'Authorization' : state.data.token
      }

      axios.post(state.data.url+'/linkroom/api/v1/logout','', {
        headers: headers
      })
      .then(response => {
        commit("settoken",null);

              })
                //Perform Success Action
            
      },
      syncad({commit}){
        commit("setloadsync",true);
        const headers = {"Authorization": state.data.token}

        axios.post(state.data.url+'/linkroom/api/v1/authen','',{headers})

        .then((response) => {
          if(response.data.status_code === 200){
            actions.getlistuser({commit})
          }
        })

      },
      getdashboard({commit}){
        const headers = {
          'Authorization' : state.data.token
      }
      // con
      axios.post(state.data.url+'/linkroom/api/admin/v1/dashboard','', {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            // console.log(response.data.listbooking)
            // console.log(response.data.status)
            commit("setdashboard",response.data.status);
            
          }

        })


      },      
      getbooking({commit}){
        // console.log('getbooking')
        const headers = {
          'Authorization' : state.data.token
      }
      // con
      axios.post(state.data.url+'/linkroom/api/admin/v1/getbooking','', {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            // console.log(response.data.listbooking)
            console.log(response.data.header)
            commit("setheader",response.data.header)
            commit("setdatatable",response.data.listbooking)
            commit("setshowtable",true)
            
          }
          // if(response.data.status_code == 201){
          //   console.log(response.data)
          // }
        })


      },
      
      getlistuser({commit})
      {
        const headers = {
          'Authorization' : state.data.token
      }
      axios.post(state.data.url+'/linkroom/api/admin/v1/listuser','', {
        headers: headers
      })
      .then(response => {
        if(response.data.status_code === 200){
          // console.log(response.data.listbooking)
          // console.log(response.data.header)
          // commit("setheader",response.data.listbooking)c
          // console.log(response.data)
          commit("setdatatable",response.data.data)
          
          commit("setshowtable",true)
          commit("setloadsync",false);
          
        }
        // if(response.data.status_code == 201){
        //   console.log(response.data)
        // }
      })
      },
      
      getlistequipment({commit}){
        
          const headers = {
            'Authorization' : state.data.token
        }
        axios.post(state.data.url+'/linkroom/api/admin/v1/listequipment','', {
          headers: headers
        })
        .then(response => {
          if(response.data.status_code === 200){
            // console.log(response.data.listbooking)
            // console.log(response.data.header)
            // commit("setheader",response.data.listbooking)c
            console.log(response.data)
            commit("setdatatable",response.data.data)
            
            commit("setshowtable",true)
            
          }
          // if(response.data.status_code == 201){
          //   console.log(response.data)
          // }
        })

      },
      getlistroom({commit}){
        const headers = {
          'Authorization' : state.data.token
      }
      axios.post(state.data.url+'/linkroom/api/admin/v1/listroom','', {
        headers: headers
      })
      .then(response => {
        if(response.data.status_code === 200){

          // console.log(response.data)
          commit("setdatatable",response.data.data)
          
          commit("setshowtable",true)
          
        }
        
      })

      },
      getmonitor({commit}){
        
        const headers = {
          'Authorization' : state.data.token
      }
        //monitor
        axios.post(state.data.url+'/linkroom/api/admin/v1/monitor','', {
          headers: headers
        })
        .then(response => {
          // console.log(response.data.status.monitor)
          // console.log(response.data)
          // console.log(response.data.status.table.data)
          
          // console.log(response.data.status_code)
          if(response.data.status_code === 200){
            commit("setmonitor",response.data.status.monitor.data)
            commit("setdatatablemonitor" , response.data.status.table.data)
          }
        })
    },
                 
}

const mutations = {
    setalart(state,text){
      state.data.alaert_text = text
      state.data.alart = true
    },
    setdashboard (state,data){
      // console.log(data)
      // console.log(state.data.count_booking)
      state.data.count_booking = data.count_booking
      state.data.count_user = data.count_user
      state.data.room_close = data.room_close
      state.data.room_ready = data.room_ready

      state.data.chart_booking_data = data.chart_booking.data
      state.data.chart_booking_name = data.chart_booking.name

      state.data.chart_booking_day_data[0].data = data.chart_booking_day.data
      state.data.chart_booking_day_name = data.chart_booking_day.name

      state.data.chart_booking_time[0].data = data.chart_booking_time.data

    },
    setshowtable(state,payload){
      state.data.showtable = payload
    },
    setloadsync(state,payload){
      state.data.loadsync = payload
    },
    setheader(state,payload){
      state.data.header = payload
    },
    setdatatable(state,payload){
      state.data.datatable = payload
    },
    setemail(state,payload){
        state.data.email = payload.get('email')
        
        // state.user.email = 
    },
    settoken (state,token){
      state.data.token = token
    },
      seterror(state,item)
      {
        state.data.error_status = item
      },
      setmenusubject (state,menu){
        state.user.subject_menu = menu
      },
      setwating (state,status){
        state.data.waiting = status
      },
      setsnackbartext (state,text){
        // console.log(text)
        state.user.returnapitext = text.text
        state.user.returnapicode = text.status_code
      },
      setsnackbar (state,status){
        state.user.returnapistatus = status
      },
      setpage(state,item)
      {
        state.data.com = item
        // console.log(state.data.com)
      },
      setmonitor (state,item)
      {
        state.data.monitor = item
      } ,
      setdatatablemonitor (state,item)
      {
        state.data.datatablemonitor = item
      }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,    
}